import { SidebarTabLayout } from '../shared/SidebarTabLayout';
import {
  Narration,
  NarrationBubble,
  narrationModel,
} from '../../../../../features/narration';
import { pagesModel, usePagePermissions } from '../../../../../features/pages';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

export const NarrationTab = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(
    pagesModel.selectors.selectCurrentPageWithError
  );

  const pagePermissions = usePagePermissions(currentPage);

  useEffect(() => {
    return () => {
      dispatch(narrationModel.actions.resetRecorder());
    };
  }, [dispatch]);

  return (
    <div className="w-80">
      <SidebarTabLayout>
        <NarrationBubble />
        {pagePermissions.isCanEditVideoNarration && <Narration />}
      </SidebarTabLayout>
    </div>
  );
};
